import initI18n from "@ms/shared/i18n/create_i18n";
import resources from "./resources";

const i18n = initI18n(resources);

export default i18n;
